module.exports = __webpack_public_path__ + "static/img/main_top_1.fb4c570.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/main_top_1.png
// module id = fFpt
// module chunks = 1